import { Module } from 'vuex'
import { IPriceDetails, IRootState } from '@/@types'
import state from './state'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const priceDetails: Module<IPriceDetails, IRootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}

export default priceDetails
